import { render } from "./uiDescriptionListItem.vue?vue&type=template&id=b9f7ec64"
import script from "./uiDescriptionListItem.vue?vue&type=script&lang=js"
export * from "./uiDescriptionListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__